import { render, staticRenderFns } from "./NamePictureView.vue?vue&type=template&id=31ac24af&scoped=true"
import script from "./NamePictureView.vue?vue&type=script&lang=js"
export * from "./NamePictureView.vue?vue&type=script&lang=js"
import style0 from "./NamePictureView.vue?vue&type=style&index=0&id=31ac24af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac24af",
  null
  
)

export default component.exports